import cn from 'classnames';
import type { FC } from 'react';

import styles from './CardApprovalProbability.module.scss';

interface Props {
  category?: string;
  isNewDesignCard?: boolean;
  className?: string;
}

const CATEGORY_LABELS_MAP_CARD_V1: { [k: string]: string } = {
  high: 'Высокое',
  medium: 'Среднее',
  low: 'Низкое',
};

const CATEGORY_LABELS_MAP_CARD_V2: { [k: string]: string } = {
  high: 'Высокая',
  medium: 'Средняя',
  low: 'Низкая',
};

const DEFAULT_LABEL_CARD_V2 = 'Нет данных';
const DEFAULT_LABEL_CARD_V1 = '—';

export const CardApprovalProbability: FC<Props> = ({ category = '', isNewDesignCard = true, className }) => {
  const label = isNewDesignCard ? CATEGORY_LABELS_MAP_CARD_V2[category] : CATEGORY_LABELS_MAP_CARD_V1[category];
  const defaultLabel = isNewDesignCard ? DEFAULT_LABEL_CARD_V2 : DEFAULT_LABEL_CARD_V1;

  return <div className={cn(styles.root, styles[category], className)}>{label || defaultLabel}</div>;
};
